import React from 'react';
export const FhirClientContext = React.createContext({});
